// src/modules/Courier/pages/CourierModal/pages/DispatchPage.jsx
import React, { useEffect } from 'react';
import { useModalPage } from '../CourierModal.jsx';
import { useRouteStore } from '../../Route/useRouteStore';

export default function DispatchPage() {
  const { goTo, close }        = useModalPage();
  const receipt                 = useRouteStore(s => s.selectedReceipt);

 /*const { data: receipt, isLoading } = useQuery({
    queryKey: ['receipt', selectedReceiptId],
    queryFn: () => api.get(`/receipts/${selectedReceiptId}`),
    enabled: !!selectedReceiptId,    // пока нет ID — не дергаем
  });*/

  useEffect(() => {
    if (!receipt) {
      close();
      return;
    }

    const skipTypes = ["ПоСчету","Кредит","Взаимозачет","Дилер","БезОплаты"];
    const allScanned = receipt.products.every(
      p => !p.is_marked || (p.marks?.length ?? 0) >= p.actual_quantity
    );

    // Для платежей из skipTypes: если не все отсканировано — сканируем,
    // а когда полностью — просто закрываем модалку.
    if (skipTypes.includes(receipt.payment_type)) {
      if (!allScanned) {
        goTo('scan');
      } else {
        close();
      }
    } else {
      // Для остальных платежей оставляем прежнюю логику:
      // если не все — сканируем, если все — пробиваем чек
      if (!allScanned) {
        goTo('scan');
      } else {
        goTo('issueCheck');
      }
    }
  }, [receipt, goTo, close]);

  return (
    <div style={{ padding: 20 }}>
      Определяем следующий шаг…
    </div>
  );
}
